const _map = {};

const modules = require.context('./', true, /[A-Z$]\/validation\.js$/);

modules.keys().forEach((key) => {
  const name = key.split('/')[1];
  const moduleExports = modules(key);

  // Process default export
  if (moduleExports.default) {
    moduleExports.default.key = name;
    const components = moduleExports.default?.components ?? {};
    Object.values(components).forEach((x) => x && (x.key = name));
    _map[name] = moduleExports.default;
  }

  // Process named exports
  for (const [exportName, ExportClass] of Object.entries(moduleExports)) {
    if (exportName === 'default') {
      continue; // Skip default, already processed above
    }

    // Only include classes that extend ValidationInterface
    if (ExportClass && typeof ExportClass === 'function') {
      const combinedName = `${name}.${exportName}`;
      _map[combinedName] = ExportClass;
    }
  }
});

export default _map;
